<template>
    <div class="title">
        <span>Service Teams</span>
        <div>
            <DxButton hint="Add Team - Delete or TBD" icon="add" styling-mode="contained" type="normal" @click="onCreateTeam" />
        </div>
    </div>
    <hr/>
    <div v-for="(item, index) in props.data" :key="item.id" class="teamlist-container">
        <hr style="padding-bottom: 6px;" v-if="props.data.length > 0 && index > 0"/>  
        <ServiceTeam :team="item" @reload="reload">         
        </ServiceTeam>
    </div>
</template>

<script lang="ts" setup>
import { DxButton } from 'devextreme-vue';
import ServiceTeam  from './ServiceTeam.vue';
import { ServiceTeamItem } from '@/services/entities/ServiceTeams/ServiceTeamItem';


const props = defineProps({
    data: { Type: Array as () => ServiceTeamItem[], default: () => [] },    
});


const emit = defineEmits(['reload', 'createNew']);

function reload(teamId: any) {
    emit("reload", teamId);
}

function onCreateTeam() {
    emit("createNew");
}
</script>
<style lang="scss" scoped>
.teamlist-container {
    overflow-y: auto;
    max-height: 420px;
}
.title {
    font-size: 16px;
    font-weight: bold;
    flex-flow: row;
    display: flex;
    justify-content: space-between;
}
</style>